import { ActionTypes } from '../constants/index';

export const feedbackmanagement = (payload: any) => ({
  type: ActionTypes.FEEDBACK_MGMT_LIST_REQUEST,
  payload,
});
